import { render, staticRenderFns } from "./goodDetail.vue?vue&type=template&id=74ac7188&scoped=true&"
import script from "./goodDetail.vue?vue&type=script&lang=js&"
export * from "./goodDetail.vue?vue&type=script&lang=js&"
import style0 from "./goodDetail.vue?vue&type=style&index=0&id=74ac7188&lang=scss&scoped=true&"
import style1 from "./goodDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ac7188",
  null
  
)

export default component.exports